import { TypeRootState } from '../store';

export const selectAuthData = (state: TypeRootState) => state.auth;
